module.exports = __webpack_public_path__ + "static/media/0_2020_06_11.d425d0ed.jpg";